/* eslint-disable react/prop-types */
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
  Stack,
  darken,
  Grid,
  Alert,
} from "@mui/material";
import theme from "assets/theme";
import { useEffect, useMemo, useState } from "react";
import { APP_URL, PaperComponent } from "../../utils/constants";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import dayjs from "dayjs";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { API_ROUTES } from "../../utils/constants";
import { AlertState } from "states";
import { useRecoilState } from "recoil";

const InformationSanPham = ({ data, open, onClose }) => {
  const [tableInfor, setTableInfor] = useState({});
  const axiosPrivateInstance = useAxiosPrivate();
  const [errors, setErrors] = useState();
  const [validationErrors, setValidationErrors] = useState({});
  // state lỗi giá trị từ form
  const fullScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [rowSelection, setRowSelection] = useState({});
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState("lg");
  const [alert, setAlert] = useRecoilState(AlertState);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const handelClear = () => {
    onClose();
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "chuthe_ten",
        header: "Chủ thể",
        size: 150,
      },
      {
        accessorKey: "nhomsanpham_ten",
        header: "Nhóm sản phẩm",
        size: 150,
      },
      {
        accessorKey: "ma",
        header: "Mã sản phẩm",
        size: 120,
      },
      {
        accessorKey: "ten",
        header: "Tên sản phẩm",
        size: 200,
      },
      {
        accessorKey: "hang",
        header: "Hạng",
        size: 95,
        muiTableBodyCellProps: ({ cell }) => ({
          sx: {
            align: "center",
            backgroundColor:
              cell.getValue() > 3 ? "rgba(22, 184, 44, 0.5)" : undefined,
            fontWeight:
              cell.column.id === "hang" && cell.getValue() > 3 ? "700" : "400",
          },
        }),
      },
      {
        accessorKey: "ngaycongnhan",
        header: "Ngày công nhận",
        size: 120,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return dayjs(value).isValid()
            ? dayjs(value).format("DD/MM/YYYY")
            : value;
        },
      },
    ],
    []
  );
  useEffect(() => {
    if (validationErrors?.another) {
      setAlert({
        alert: true,
        message: validationErrors?.another,
        type: "error",
      });
    } else {
      setErrors(validationErrors);
    }
  }, [validationErrors]);
  useEffect(() => {
    if (open) {
      setRowSelection({});
    }
  }, [open]);
  useEffect(() => {
    if (data) {
      setTableInfor(data);
    } else {
      setTableInfor({});
    }
  }, [data]);
  const handleToSend = async () => {
    const values = Object.keys(rowSelection).map((key) => Number(key));
    let data = {
      idSanpham: values,
      ipFrontend: APP_URL,
    };
    try {
      if (values?.length > 0) {
        const response = await axiosPrivateInstance.put(
          API_ROUTES.GOITHONGBAO,
          {
            ...data,
          }
        );
        setTableInfor(response.data["data"]);
        setAlert({
          alert: true,
          message: "Gởi thông báo thành công!",
          type: "success",
        });
      } else {
        setAlert({
          alert: true,
          message:
            "Bạn chưa chọn sản phẩm nào. Vui lòng chọn sản phẩm để gởi thông báo!",
          type: "warning",
        });
      }
    } catch (error) {
      const ms = error.response.data[0];
      setAlert({ alert: true, message: ms, type: "warning" });
    }
  };
  return (
    <Dialog
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      fullScreen={fullScreen}
      open={open}
      PaperComponent={PaperComponent}
      onClose={handelClear}
      scroll="paper"
      PaperProps={{
        sx: {
          "@media (min-width: 768px)": {
            minWidth: "40rem",
          },
          height: "100%",
        },
      }}
    >
      {/* Form*/}
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          height: "100%",
        }}
      >
        {/* Tiêu đề modal - tham số title */}
        <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#ffffff" }}>
          Thông báo sản phẩm OCOP hết hạn
          <IconButton
            aria-label="close"
            onClick={handelClear}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Box
          sx={{
            width: "100%",
            bgcolor: "background.paper",
            borderColor: "divider",
            padding: "1rem 1rem 0 1rem",
          }}
        ></Box>
        <DialogContent dividers sx={{ overflow: "auto", paddingTop: "0" }}>
          <Box>
            {errors && errors.error ? (
              <Grid container sx={{ textAlign: "center", mb: 0 }}>
                <Grid item xs={12}>
                  <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                    {errors.error}
                  </Alert>
                </Grid>
              </Grid>
            ) : (
              ""
            )}
          </Box>
          <MaterialReactTable
            muiToolbarAlertBannerProps={
              isError
                ? {
                    color: "error",
                    children: "Lỗi khi lấy dữ liệu",
                  }
                : undefined
            }
            enableRowNumbers
            rowNumberMode="static"
            columns={columns}
            data={tableInfor}
            enableRowActions={false}
            enableMultiRowSelection={true}
            enableRowSelection={true}
            getRowId={(row) => row.id} // Make sure each row has a unique ID
            onRowSelectionChange={setRowSelection}
            positionToolbarAlertBanner="head-overlay"
            enableFilters={true}
            enableHiding={false}
            enableColumnOrdering={false}
            enableDensityToggle={true}
            enableColumnResizing
            enableGrouping
            manualPagination
            onPaginationChange={setPagination}
            rowCount={rowCount}
            localization={MRT_Localization_VI}
            positionActionsColumn="last"
            displayColumnDefOptions={{
              "mrt-row-actions": {
                size: 80,
              },
            }}
            renderTopToolbarCustomActions={() => (
              <Stack spacing={2} direction="row" color="white">
                <Button
                  variant="contained"
                  startIcon={<SendIcon />}
                  sx={{ color: "#ffffff" }}
                  onClick={() => handleToSend()}
                >
                  Gởi thông báo
                </Button>
              </Stack>
            )}
            initialState={{
              isLoading: true,
              columnVisibility: {
                id: false,
              },
              density: "compact",
            }}
            state={{
              rowSelection,
              pagination,
              isLoading,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
            }}
            muiTablePaperProps={{
              elevation: 0,
              sx: {
                borderRadius: "0",
                border: "1px solid rgb(211 225 245)",
                backgroundColor: "#fff",
              },
            }}
            muiTableBodyProps={{
              sx: (theme) => ({
                "& tr:nth-of-type(odd)": {
                  backgroundColor: darken(
                    theme.palette.background.default,
                    0.1
                  ),
                },
              }),
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            type="submit"
            variant="contained"
            startIcon={<Cancel />}
            size="small"
            onClick={handelClear}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Đóng
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};
export default InformationSanPham;
